import { render, staticRenderFns } from "./FreestyleContentTab.vue?vue&type=template&id=0e8906b7&scoped=true&"
import script from "./FreestyleContentTab.vue?vue&type=script&lang=js&"
export * from "./FreestyleContentTab.vue?vue&type=script&lang=js&"
import style0 from "./FreestyleContentTab.vue?vue&type=style&index=0&id=0e8906b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8906b7",
  null
  
)

export default component.exports